module.exports = __webpack_public_path__ + "img/TGI Fridays.ba632a40.svg";